// actions/websocketActions.js
export const connectWebSocket = (url) => ({
  type: 'WEBSOCKET_CONNECT',
  payload: { url }
});

export const disconnectWebSocket = () => ({
  type: 'WEBSOCKET_DISCONNECT'
});
